import { useNavigate } from "react-router-dom"

import { Button } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { FolderViewOutlined } from "@/icons"

import styles from "./FooterMenu.module.scss"

import { FooterMenuProps } from "."

export const FooterMenu: React.FC<FooterMenuProps> = (props) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { applyDisabled, manageScopesDisabled, actions } = props

  return (
    <div className={styles.container}>
      <Button
        icon={<FolderViewOutlined />}
        disabled={manageScopesDisabled}
        onClick={() => {
          actions.setOpenKeys([])
          navigate("/settings/scopes")
        }}
      >
        {t("settings.scopes.menu.manageScopes")}
      </Button>
      <div>
        <Button
          disabled={applyDisabled}
          onClick={() => {
            actions.applyScope()
            actions.setOpenKeys([])
          }}
        >
          {t("general.apply")}
        </Button>
      </div>
    </div>
  )
}
